import { QrCode } from 'lucide-react'

export default function ActionQRCode(props) {

    const { text, onClick } = props

    return (
        <>
            <QrCode size={14} className='action_btn text-primary me-3'
                onClick={onClick}
                data-tooltip-id='global-tooltip'
                data-tooltip-content={text}
                data-tooltip-place="bottom"
                data-tooltip-class-name='bg-primary tooltip_msg'
            />
        </>
    )
}